import { RadioFilter } from "../RadioFilter"

import type { InsightsFilterProps } from "."
import type { RadioFilterItemProps } from "../RadioFilter"

export const InsightsFilter = (props: InsightsFilterProps) => {
  const { filters, isLoading, placement, title, filtersMeta, prefix } = props
  const items = filters
    .filter(
      ({ key: insightKey }: { key: keyof typeof filtersMeta }) =>
        !!filtersMeta[
          prefix
            ? (insightKey?.replace(prefix, "") as keyof typeof filtersMeta)
            : insightKey
        ]
    )
    .map(
      (filter: {
        key: keyof typeof filtersMeta
        options?: Array<{
          label: string
          value: string
          displayLabel?: boolean
        }>
      }) => ({
        ...filtersMeta[
          prefix
            ? (filter.key.replace(prefix, "") as keyof typeof filtersMeta)
            : filter.key
        ],
        ...filter,
        options: filter.options || [
          { label: "Yes", value: "yes", displayLabel: true },
          { label: "No", value: "no", displayLabel: true }
        ]
      })
    )
    .sort((a: any, b: any) =>
      `${a.order}`.localeCompare(`${b.order}`)
    ) as RadioFilterItemProps[]

  return (
    <RadioFilter
      title={title || "Insights"}
      items={items}
      isLoading={isLoading}
      addCounter={true}
      name="insights"
      placement={placement}
    />
  )
}
